export default {"src":"/_next/static/media/logo-kenzie.51427f9d.svg","height":207,"width":206};